import config from 'config'
import { getAuth, getIdToken } from 'firebase/auth'
import { firebaseApp } from 'state/store'

export type FetchOptions = {
	method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
	body?: Record<any, any>
	headers?: Record<string, string>
}

export const createApiCaller = (apiPath: string) => {
	return async (route: string, options: FetchOptions) => {
		const currentUser = getAuth(firebaseApp).currentUser

		if (!currentUser) {
			console.error('Unauthenticated.')
			return
		}

		const token = await getIdToken(currentUser)

		return fetch(`${config.functions.baseURL}${apiPath}${route}`, {
			method: options.method,
			headers: {
				Authorization: 'Bearer ' + token,
				'Content-Type': 'application/json',
				...options.headers,
			},
			body: options.body ? JSON.stringify(options.body) : undefined,
		})
	}
}

type ApiResponse<T> =
	| { success: true; data: T }
	| {
			success: false
			ex?: any
	  }

export const apiToActionRes = async <T = any>(
	apiCallPromise: Promise<Response | undefined>,
): Promise<ApiResponse<T>> => {
	try {
		const res = await apiCallPromise
		if (!res?.ok) {
			let ex
			if (res) {
				const json = await res.json()
				ex = json.ex || { message: res.statusText }
			} else {
				ex = { message: 'Unknown api error' }
			}
			return { success: false, ex }
		}
		const data = (await res.json()) as T
		return {
			success: true,
			data: {
				...data,
			},
		}
	} catch (e) {
		return {
			success: false,
			ex: e,
		}
	}
}
